import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';

const bmiCalculator = {
    variables : {
        gender : null,
        name:  null,
    },
    methods : {
        calculateBMI  : (el,bmiText)=>{
            const name = $(el).find('.bmi-calculator__question-name').val();
            const feet = $(el).find('.bmi-calculator__height-feet').val();
            const inches = $(el).find('.bmi-calculator__height-inch').val();
            const weight = $(el).find('.bmi-calculator__weight').val();
            if (weight && feet >= 0 && inches >= 0){
                let totalInches = parseFloat(feet * 12) + parseFloat(inches);
                let heightInMeters = parseFloat(totalInches) * 0.0254;
                let bmi = (weight / (heightInMeters * heightInMeters)).toFixed(2);
                const resultBmi = $(el).find('.bmi-calculator__category-bmi');
                const template = bmiText
                .replace("{customerName}", `<span class="text-blue-400">${name.split(' ')[0]}</span>`)
                .replace("{result}", `<span class="text-blue-400">${bmi}</span>`);
                $(resultBmi).html(template);
                const category = bmiCalculator.methods.getCategory(bmi);
                $(el).find('.bmi-calculator__category-result').text(category);
                bmiCalculator.methods.handlePointer(el,bmi);
            }
        },
        getCategory : (bmi)=>{
            if (bmi < 18.5) {
                return "Underweight";
              } else if (bmi >= 18.5 && bmi < 25) {
                return "Normal";
              } else if (bmi >= 25 && bmi < 30) {
                return "Overweight";
              } else if (bmi >= 30 && bmi < 35) {
                return "Obese";
              } else {
                return "Morbid Obese";
              }
        },
        handleGenderSelection  :(el)=>{
            $($(el).find('.bmi-calculator__options--name')[0]).addClass('selected');
            $(el).find('.bmi-calculator__options--name').on(CONSTANT.eventsListners.CLICK,(e)=>{
                $(el).find('.bmi-calculator__options--name').removeClass('selected');
                $(e.target).addClass('selected');
            });
        },
        handleCalculate : (el)=>{
            const bmiText = $(el).find('.bmi-calculator__category-bmi').data('text');
            const bmiName = $(el).find('.bmi-calculator__questions--field').text();
            // The fields sit inside the question sentence, so they are named
            // directly (WCAG 1.3.1, 3.3.2, 4.1.2)
            const nameInput = $('<input>', {
                type: 'text',
                placeholder: '',
                'aria-label': 'Your name',
                autocomplete: 'name',
                class: 'bmi-calculator__question-name bg-none text-black-200 px-1 my-4 my-md-2 text-center text-capitalize'
            });
            const ageInput = $('<input>', {
                type: 'text',
                placeholder: '',
                'aria-label': 'Your age in years',
                min:1,
                max:80,
                class: 'bmi-calculator__question-age bg-none text-black-200 mx-1 px-1',
                maxLength:3
            });
            const htmlContent = bmiName
                .replace("{customerName}", nameInput[0].outerHTML)
                .replace("{customerage}", ageInput[0].outerHTML);
            $('.bmi-calculator__questions--field').html(htmlContent);
            $(el).find('.bmi-calculator__question-name').on(CONSTANT.eventsListners.INPUT,function(e){
                $(el).find('.bmi-calculator__question-name').removeClass('border-red-300');
                $(el).find('.bmi-calculator__questions--name-age .error-text').addClass('invisible');
                $(el).find('.bmi-calculator__questions--name-age .error-text').text('Please fill the name.');
                const $this = $(this);
                let value = $this.val().replace(/[^a-zA-Z\s]/g, '');
                $this.val(value);
                if($this.val().length === 0){
                    $this.closest('.bmi-calculator__questions--name-age').find('.error-text').removeClass('invisible');
                    $this.closest('.bmi-calculator__questions--name-age').find('.error-text').text('Name is required');
                }
                else if($this.val().length < 3){
                    $this.closest('.bmi-calculator__questions--name-age').find('.error-text').removeClass('invisible');
                    $this.closest('.bmi-calculator__questions--name-age').find('.error-text').text('Name should contain at least 3 characters');
                }
                else{
                    $this.closest('.bmi-calculator__questions--name-age').find('.error-text').addClass('invisible');
                }
            });
            $(el).find('.bmi-calculator__question-age').on(CONSTANT.eventsListners.INPUT,function(e){
                const $this = $(this);
                let value = $this.val().replace(/[^0-9]/g, '');
                let numericValue = parseInt(value, 10);
                if (isNaN(numericValue) || value === '') {
                   numericValue = 0;
                }
                $this.val(numericValue);
            });
            $(el).find('.bmi-calculator__calculate').on(CONSTANT.eventsListners.CLICK, (e)=>{
                const name = $(el).find('.bmi-calculator__question-name').val();
                const feet = $(el).find('.bmi-calculator__height-feet').val();
                const inches = $(el).find('.bmi-calculator__height-inch').val();
                const weight = $(el).find('.bmi-calculator__weight').val();
            bmiCalculator.variables.gender=$(el).find('.bmi-calculator__options--name.selected').text();

                if(name && feet && inches && weight){
                    bmiCalculator.methods.calculateBMI(el,bmiText);
                    $(el).find('.bmi-calculator__results').removeClass('d-none');
                    $(el).find('.bmi-calculator__questions').addClass('d-none');

                    localStorage.setItem("bmiName",name);
                    bmiCalculator.variables.name=name;
                    localStorage.setItem("bmiweight",weight);
                    localStorage.setItem('bmifeet',feet);
                    localStorage.setItem('bmiinches',inches);
                }else{
                    if(!name){
                        $(el).find('.bmi-calculator__question-name').addClass('border-red-300');
                        $(el).find('.bmi-calculator__questions--name-age .error-text').removeClass('invisible');
                    }
                    if(!feet){
                        $(el).find('.bmi-calculator__height-feet').addClass('border-red-300');
                        $(el).find('.bmi-calculator__height-text--input .error-text').removeClass('invisible');
                    }
                    if(!inches){
                        $(el).find('.bmi-calculator__height-inch').addClass('border-red-300');
                        $(el).find('.bmi-calculator__height-text--input .error-text').removeClass('invisible');
                    }
                    if(!weight){
                        $(el).find('.bmi-calculator__weight').addClass('border-red-300');
                        $(el).find('.bmi-calculator__weight-text--input .error-text').removeClass('invisible');
                    }
                }
            });
            bmiCalculator.methods.handleReturn(el);
        },
        handleReturn : (el)=>{
            $(el).find('.bmi-calculator__ctas--return').on(CONSTANT.eventsListners.CLICK,(e)=>{
                $(el).find('.bmi-calculator__results').addClass('d-none');
                $(el).find('.bmi-calculator__questions').removeClass('d-none');
            });
        },
        handlePointer : (parentEl,bmi)=>{
            const categories = [
                { max: 18.5, color: 'bg-blue-300' },
                { max: 25, color: 'bg-green-100' },
                { max: 30, color: 'bg-yellow-300' },
                { max: 35, color: 'bg-red-200' },
                { max: Infinity, color: 'bg-red-500' }
            ];
            let categoryIndex = 0;
            for (let i = 0; i < categories.length; i++) {
                if (bmi <= categories[i].max) {
                    categoryIndex = i;
                    break;
                }
            }
            const totalCategories = categories.length;
            const categoryWidth = 100 / totalCategories;
            const positionPercentage = (categoryIndex * categoryWidth) + (categoryWidth / 2);
            $(parentEl).find('.bmi-calculator__category--pointer').addClass('d-none');
            const selectedPointer = $(parentEl)
            .find('.bmi-calculator__category')
            .eq(categoryIndex)
            .find('.bmi-calculator__category--pointer');
            if($(window).width() >= CONSTANT.breakpoints.md){
                selectedPointer.removeClass('d-none').css({
                    'left': `calc(${positionPercentage}%)`
                });
            }else{
                selectedPointer.removeClass('d-none').css({
                    'top': `calc(${positionPercentage}%)`,
                    'left': '24px'
                });
            }
        },
        manageHeight : (el)=>{
                const slider = $(el).find('.bmi-calculator__height-progress').find('.slider');
                const feetInput = $(el).find('.bmi-calculator__height-feet');
                const inchesInput = $(el).find('.bmi-calculator__height-inch');
                const tooltip = $(el).find('.bmi-calculator__height-progress .tooltip-point');
                $(slider).on(CONSTANT.eventsListners.INPUT, function() {
                    let value = parseFloat($(slider).val()).toFixed(1);
                    let percentage = ((value -  slider.attr('min')) / (slider.attr('max') - slider.attr('min'))) * 100;
                    $(slider).css('background',`linear-gradient(to right, #FFC20E ${percentage}%, #FFF8E2 ${percentage}%)`);
                    let feet = Math.floor(value);
                    let inches = Math.round((value - feet) * 10) ;
                    $(feetInput).val(feet);
                    $(inchesInput).val(inches);
                    $(tooltip).text(`${feet}'${inches}"`);
                    $(tooltip).css('left',`${percentage}%`);
                    $(feetInput).removeClass('border-red-300');
                    $(inchesInput).removeClass('border-red-300');
                    $(el).find('.bmi-calculator__height-text--input .error-text').addClass('invisible');
                });
                $(feetInput).on(CONSTANT.eventsListners.INPUT, function() {
                    let feet = parseInt($(feetInput).val());
                    let inches = parseInt($(inchesInput).val());
                    if (isNaN(feet) || feet < 0) {
                        feet = 0;
                    } else if (feet > 8) {
                        feet = 8;
                    } else if(feet == 8){
                        inches = 0;
                    }
                    if (isNaN(inches) || inches < 0) {
                        inches = 0;
                    } else if (inches >= 12) {
                        inches = 0;
                        feet = Math.min(feet + 1, 8);
                    }
                    const value = feet + (inches / 12);
                    $(slider).val(value.toFixed(1));
                    let percentage = ((value - slider.attr('min')) / (slider.attr('max') - slider.attr('min'))) * 100;
                    $(slider).css('background', `linear-gradient(to right, #FFC20E ${percentage}%, #FFF8E2 ${percentage}%)`);
                    $(feetInput).val(feet);
                    $(inchesInput).val(inches);
                    $(tooltip).text(`${feet}'${inches}"`);
                    $(tooltip).css('left', `${percentage + 2}%`);
                    $(feetInput).removeClass('border-red-300');
                    $(inchesInput).removeClass('border-red-300');
                    $(el).find('.bmi-calculator__height-text--input .error-text').addClass('invisible');
                });

                $(inchesInput).on(CONSTANT.eventsListners.INPUT, function() {
                    let feet = parseInt($(feetInput).val());
                    let inches = parseInt($(inchesInput).val());
                    if (isNaN(feet) || feet < 0) {
                        feet = 0;
                    } else if (feet > 8) {
                        feet = 8;
                    }
                    if (isNaN(inches) || inches < 0) {
                        inches = 0;
                    } else if (inches >= 12) {
                        inches = 0;
                        feet = Math.min(feet + 1, 8);
                    } else if(feet == 8){
                        inches = 0;
                    }
                    const value = feet + (inches / 12);
                    $(slider).val(value.toFixed(1));
                    let percentage = ((value - slider.attr('min')) / (slider.attr('max') - slider.attr('min'))) * 100;
                    $(slider).css('background', `linear-gradient(to right, #FFC20E ${percentage}%, #FFF8E2 ${percentage}%)`);
                    $(feetInput).val(feet);
                    $(inchesInput).val(inches);
                    $(tooltip).text(`${feet}'${inches}"`);
                    $(tooltip).css('left', `${percentage + 2}%`);
                    $(feetInput).removeClass('border-red-300');
                    $(inchesInput).removeClass('border-red-300');
                    $(el).find('.bmi-calculator__height-text--input .error-text').addClass('invisible');
                });
        },
        manageWidth:(el)=>{
            const slider = $(el).find('.bmi-calculator__weight-progress').find('.slider');
            const tooltip = $(el).find('.bmi-calculator__weight-progress .tooltip-point');
                const weightInput = $(el).find('.bmi-calculator__weight');
                $(slider).on(CONSTANT.eventsListners.INPUT, function() {
                    let value = parseFloat($(slider).val()).toFixed(1);
                    let percentage = ((value -  slider.attr('min')) / (slider.attr('max') - slider.attr('min'))) * 100;
                    $(slider).css('background',`linear-gradient(to right, #FFC20E ${percentage}%, #FFF8E2 ${percentage}%)`);
                    $(weightInput).val(Math.floor(value));
                    $(tooltip).val(Math.floor(value));
                    $(tooltip).css('left',`${percentage + 2}%`);
                    $(weightInput).removeClass('border-red-300');
                    $(el).find('.bmi-calculator__weight-text--input .error-text').addClass('invisible');
                });
                $(weightInput).on(CONSTANT.eventsListners.INPUT, function() {
                    let weightValue = $(weightInput).val();
                    if (weightValue < 0) {
                        weightValue = 0;
                    } else if (weightValue > 120) {
                        weightValue = 120;
                    }
                    $(slider).val(weightValue);
                    let percentage = ((weightValue -  slider.attr('min')) / (slider.attr('max') - slider.attr('min'))) * 100;
                    $(slider).css('background',`linear-gradient(to right, #FFC20E ${percentage}%, #FFF8E2 ${percentage}%)`);
                    let weightInKg = Math.floor(weightValue);
                    $(weightInput).val(weightInKg);
                    $(tooltip).val(Math.floor(weightInKg));
                    $(tooltip).css('left',`${percentage + 2}%`);
                    $(weightInput).removeClass('border-red-300');
                    $(el).find('.bmi-calculator__weight-text--input .error-text').addClass('invisible');
                });
        },
        handleDataLayer:(el)=>{
            $(el).find('.bmi-calculator__calculate').on('click', function(e){
                var obj = bmiCalculator.methods.dataLayerObj(e);
                createDataLayer('buttonClick', obj);
            });
            $(el).find('.bmi-calculator__ctas--return').on('click', function(e){
              var obj = bmiCalculator.methods.dataLayerObj(e);
              createDataLayer('buttonClick', obj);
            });
            $(el).find('.bmi-calculator__ctas--plans').on('click', function(e){
              var obj = bmiCalculator.methods.dataLayerObj(e);
              createDataLayer('buttonClick', obj);
            });
            $(el).find('.bmi-calculator__options--name').on('click', function(e){
              var obj = bmiCalculator.methods.dataLayerObj(e);
              createDataLayer('buttonClick', obj);
            });
        },
        init : ()=>{
            $('.bmi-calculator').each((idx,ele)=>{
                bmiCalculator.methods.handleGenderSelection(ele);
                bmiCalculator.methods.handleCalculate(ele);
                bmiCalculator.methods.manageHeight(ele);
                bmiCalculator.methods.manageWidth(ele);
                bmiCalculator.methods.handleDataLayer(ele);
        });
        },
        dataLayerObj: function (e) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                'pageSection' : "BMI Calculator",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                "gender": bmiCalculator.variables.gender ? bmiCalculator.variables.gender.replace(/\n/g, '').trim(): "",
                "name": bmiCalculator.variables.name ? bmiCalculator.variables.name: "",
            };
            return obj;
        },
    }
};
$(()=>{
    if($('.bmi-calculator').length){
        bmiCalculator.methods.init();
    }
});
